import { useDispatch, useSelector } from 'react-redux';
import { useCallback, useEffect, useState } from 'react';
import { fetchProperksProfessionalChallenge } from '../../../../actions/metricsAction';
import { createLoadingSelector } from '../../../../apis/selectors';
import { challengeStatusFilter } from '../../../mainComponents/ProPerks/utils';

const actions = ['GET_PROPERKS_PROFESSIONAL_CHALLENGE'];
const loadingSelector = createLoadingSelector(actions);
export const ROWS_PER_PAGE = 20;

export const useProfessionalChallenge = () => {
  const dispatch = useDispatch();
  const [page, setPage] = useState(1);
  const [status, setStatus] = useState(challengeStatusFilter.all);
  const statusForApi = status === challengeStatusFilter.all ? undefined : status;

  const userProfile = useSelector((state) => state.users.currentUser);
  const { data, totalElements: total } = useSelector(
    (state) => state.metrics?.properksProfessionalChallenges,
  );
  const totalPages = Math.ceil(total / ROWS_PER_PAGE);

  const isLoading = useSelector((state) => loadingSelector(state));

  const fetchData = useCallback(() => {
    dispatch(
      fetchProperksProfessionalChallenge({
        profId: userProfile?.id,
        limit: ROWS_PER_PAGE,
        status: statusForApi,
        page: 1,
      }),
    );
  }, [dispatch, statusForApi, userProfile?.id]);

  useEffect(() => {
    fetchData();
  }, [fetchData, statusForApi]);

  const handleTableChange = (pageTarget) => {
    setPage(pageTarget);
    dispatch(
      fetchProperksProfessionalChallenge({
        profId: userProfile?.id,
        limit: ROWS_PER_PAGE,
        status: statusForApi,
        page: pageTarget,
      }),
    );
  };

  return {
    data,
    page,
    total,
    totalPages,
    isLoading,
    fetchData,
    handleTableChange,
    status,
    setStatus,
  };
};